import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEmail2Unread"><Path fillRule="evenodd" clipRule="evenodd" d="M22 9.11816L12 14.1182L4 10.1172V18H12V20H2V4H22V9.11816Z" fill="currentColor"/><Path d="M19.5 14C21.433 14 23 15.567 23 17.5C23 19.433 21.433 21 19.5 21C17.567 21 16 19.433 16 17.5C16 15.567 17.567 14 19.5 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Unread;
